import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InboxAiOverviewComponent } from '@app/modules/guest-experience/pages/inbox-ai-overview/inbox-ai-overview.component';
import { InboxAiSettingsComponent } from '@app/modules/guest-experience/pages/inbox-ai-settings/inbox-ai-settings.component';
import { SharedModule } from '@app/shared/shared.module';
import { DialogAddNewRuleComponent } from './components/dialog-add-new-rule/dialog-add-new-rule.component';
import { DialogCreateIntentComponent } from './components/dialog-create-intent/dialog-create-intent.component';
import { DialogDeleteRulesetComponent } from './components/dialog-delete-ruleset/dialog-delete-ruleset.component';
import { DialogDeleteUpcomingScheduledMessagesComponent } from './components/dialog-delete-upcoming-scheduled-messages/dialog-delete-upcoming-scheduled-messages.component';
import { DialogPreviewAgreementComponent } from './components/dialog-preview-agreement/dialog-preview-agreement.component';
import { LogDetailSidebarItemComponent } from './components/log-detail-sidebar-item/log-detail-sidebar-item.component';
import { LogDetailSidebarComponent } from './components/log-detail-sidebar/log-detail-sidebar.component';
import { LogHeroItemComponent } from './components/log-hero-item/log-hero-item.component';
import { LogSendStatusComponent } from './components/log-send-status/log-send-status.component';
import { ReviewRatingsComponent } from './components/review-ratings/review-ratings.component';
import { GuestExperienceRoutingModule } from './guest-experience-routing.module';
import { CannedResponseDetailComponent } from './pages/canned-response-detail/canned-response-detail.component';
import { CannedResponsesComponent } from './pages/canned-responses/canned-responses.component';
import { CustomCodeDetailComponent } from './pages/custom-code-detail/custom-code-detail.component';
import { CustomCodesComponent } from './pages/custom-codes/custom-codes.component';
import { EditReservationAgreementComponent } from './pages/edit-reservation-agreement/edit-reservation-agreement.component';
import { LogDetailComponent } from './pages/log-detail/log-detail.component';
import { LogComponent } from './pages/log/log.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { QuestionDetailComponent } from './pages/question-detail/question-detail.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { ReservationAgreementTemplatesComponent } from './pages/reservation-agreements/reservation-agreement-templates/reservation-agreement-templates.component';
import { ReservationAgreementsComponent } from './pages/reservation-agreements/reservation-agreements.component';
import { SignedReservationAgreementsComponent } from './pages/reservation-agreements/signed-reservation-agreements/signed-reservation-agreements.component';
import { ReviewDetailComponent } from './pages/review-detail/review-detail.component';
import { ReviewsComponent } from './pages/reviews/reviews.component';
import { RuleDetailComponent } from './pages/rule-detail/rule-detail.component';
import { RulesComponent } from './pages/rules/rules.component';

// Add your pipe here
@Pipe({
  name: 'matchPropertySearchCriteria'
})
export class MatchPropertySearchCriteriaPipe implements PipeTransform {
  transform(value: string, searchCriteria: string): boolean {
    if (!searchCriteria) {
      return true;
    }
    return value.toLowerCase().includes(searchCriteria.toLowerCase());
  }
}

@NgModule({
  declarations: [
    RulesComponent,
    RuleDetailComponent,
    CustomCodesComponent,
    CustomCodeDetailComponent,
    ReviewsComponent,
    ReviewDetailComponent,
    QuestionsComponent,
    QuestionDetailComponent,
    LogComponent,
    OverviewComponent,
    DialogAddNewRuleComponent,
    CannedResponsesComponent,
    CannedResponseDetailComponent,
    DialogDeleteRulesetComponent,
    DialogCreateIntentComponent,
    LogDetailComponent,
    LogDetailSidebarComponent,
    LogDetailSidebarItemComponent,
    LogSendStatusComponent,
    LogHeroItemComponent,
    ReviewRatingsComponent,
    DialogDeleteUpcomingScheduledMessagesComponent,
    ReservationAgreementsComponent,
    ReservationAgreementTemplatesComponent,
    EditReservationAgreementComponent,
    SignedReservationAgreementsComponent,
    DialogPreviewAgreementComponent,
    InboxAiOverviewComponent,
    InboxAiSettingsComponent,
    MatchPropertySearchCriteriaPipe
  ],
  imports: [
    CommonModule,
    GuestExperienceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class GuestExperienceModule {}
